/**
 * @module utils/promisify
 */

import resolvable from './resolvable.js'

/**
 * Promisifies a function requiring a callback
 * @param {Function} fn
 * @param {*} context
 * @returns {function(...[*]): Promise<*>}
 */
export default (
  fn,
  context = null
) => {
  return async (
    ...args
  ) => {
    const [promise, { resolve }] = resolvable()

    fn.call(context, ...args, resolve)

    return promise
  }
}
